import { getStore } from '../store/store';
import BrowserWidthBucket from '../store/schema/BrowserWidthBucket';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import setBrowserWidthBucket from '../mutators/setBrowserWidthBucket';
import calculateAvailableWidthBucket from './calculateAvailableWidthBucket';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';

export function initializeDynamicLayout() {
    window.addEventListener('resize', onWindowResize);

    // Calculate once on boot.
    setAvailableWidthBucket(LayoutChangeSource.Init);
}

/**
 * On Window resize handler.
 */
function onWindowResize() {
    setAvailableWidthBucket(LayoutChangeSource.WindowResize);
}

/**
 * Update the layout on the available app width change
 * @param source source of the width change
 */
function setAvailableWidthBucket(source: LayoutChangeSource) {
    // Update available app width bucket
    const availableWidthBucket = calculateAvailableWidthBucket(source != LayoutChangeSource.Init);

    // No-op if the width bucket did not change
    if (getStore().browserWidthBucket == availableWidthBucket) {
        return;
    }

    setBrowserWidthBucket(availableWidthBucket);

    // Make appropriate layout changes as per the available width bucket
    switch (availableWidthBucket) {
        case BrowserWidthBucket.From418_Below:
            addOverflowOnBody();
            break;

        case BrowserWidthBucket.From419_To554:
        case BrowserWidthBucket.From555_To768:
            hideOverflowOnBody();
            break;

        case BrowserWidthBucket.From769_To918:
            hideOverflowOnBody();
            break;

        case BrowserWidthBucket.From919_To999:
        case BrowserWidthBucket.From1000_To1199:
        case BrowserWidthBucket.From1200_To1399:
        case BrowserWidthBucket.From1400_To1599:
        case BrowserWidthBucket.From1600_Above:
        default:
            hideOverflowOnBody();
            break;
    }

    /* action to listen to for consumers to know that the availableWidthBucket had updated,
     * passes new availableWidthBucket
     */
    onAvailableWidthBucketChanged(availableWidthBucket, source);
}

function addOverflowOnBody() {
    document.body.style.overflowX = 'auto';
}

function hideOverflowOnBody() {
    document.body.style.overflow = 'hidden';
}
